// extracted by mini-css-extract-plugin
export var grid = "iconsGridBlock-module--grid--zYops";
export var gridItem = "iconsGridBlock-module--gridItem--fpGGo";
export var iconContainer = "iconsGridBlock-module--iconContainer--+njQQ";
export var itemTitle = "iconsGridBlock-module--itemTitle--dytpg";